import { useCallback, useMemo } from "react";

import { useStore } from "react-redux";

import { leadTypeMap } from "app/pages/sales-intelligence/domain/leads/types/lead";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import type {
    ContactsDataSource,
    ContactsFlowStrategy,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/context/ContactsFlowContext.types";
import { contactsQueryKeys } from "app/pages/sales-intelligence/sub-modules/contacts-search/query/queryKeys/queryKeyFactory";
import { selectContactSearchResultsDto } from "app/pages/sales-intelligence/sub-modules/contacts-search/store/selectors";
import type { RootState } from "single-spa/store/types";

const companyAnalysisDataSource: ContactsDataSource = {
    revealSingle: salesApiService.contacts.revealSingleContact,
    revealMultiple: salesApiService.contacts.revealContactsById,
    exportExcel: salesApiService.contacts.exportToExcel,
};

export const useCompanyAnalysisContactsFlowStrategy = (): ContactsFlowStrategy => {
    const store = useStore<RootState>();

    const getRevealCacheKey = useCallback(() => {
        const dto = selectContactSearchResultsDto(store.getState());

        return contactsQueryKeys.tableData(leadTypeMap.websites, dto);
    }, [store]);

    return useMemo<ContactsFlowStrategy>(
        () => ({
            dataSource: companyAnalysisDataSource,
            getRevealCacheKey,
        }),
        [getRevealCacheKey],
    );
};
